import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'csi-scribe-type-tab',
  templateUrl: './scribe-type-tab.component.html',
  styleUrls: ['./scribe-type-tab.component.scss'],
})
export class ScribeTypeTabComponent {
  @Input() typedTranscript = '';
  @Input() canSubmit = false;
  @Input() isSubmitting = false;

  @Output() typedTranscriptChange = new EventEmitter<string>();
  @Output() transcriptChange = new EventEmitter<void>();
  @Output() submitClicked = new EventEmitter<void>();

  onTranscriptChange() {
    this.typedTranscriptChange.emit(this.typedTranscript);
    this.transcriptChange.emit();
  }
}
